import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class SharesService {
  private url = 'shares';
  constructor(private httpClient: HttpClientService) {}

  create(params: any = {}): Promise<any> {
    return this.httpClient.post(`/matters/${params.matter_id}/${this.url}.json`, params);
  }

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  documents(params: any = {}): Promise<any> {
    return this.httpClient.get(`/matters/${params.matter_id}/${this.url}/documents.json`, params);
  }

  formOptions(matterId: number): Promise<any> {
    return this.httpClient.get(`/matters/${matterId}/${this.url}/new.json`, { form_options: true });
  }

  media(params: any = {}): Promise<any> {
    return this.httpClient.get(`/matters/${params.matter_id}/${this.url}/media.json`, params);
  }
}
